import type { ReactNode } from 'react';
import { useGetClientProfileQuery } from '@/store/api/endpoints/client/userProfileApi';
import { PageLoader } from '@/components/ui/feedback/page-loader';
import NotFoundPage from '@/pages/NotFoundPage';

export function AdminRoleGuard({ children }: { children: ReactNode }) {
  const { data, isLoading, isFetching } = useGetClientProfileQuery();

  if (isLoading || isFetching) return <PageLoader />;
  if (data?.role !== 'Admin') return <NotFoundPage />;
  return <>{children}</>;
}
